function omit(obj, fields) {
  var shallowCopy = Object.assign({}, obj);
  fields.forEach(function (el) {
    delete shallowCopy[el];
  });
  return shallowCopy;
}

export { omit as default };
